import api from './index';

export interface Profile {
  id?: number;
  user_id?: number;
  name?: string;
  photo?: string | null;
  cpf?: string;
  birthDate?: string;
  departamentId?: number;
  departamentName?: string | null;
  managedDepartamentId?: number | null;
  managedDepartamentName?: string | null;
  phone?: string;
  email?: string;
  addresses?: string[];
}

const profileUrl = '/profile';

export const profileService = {
  async getProfile(): Promise<Profile | null> {
    try {
      const response = await api.get(`${profileUrl}/me`, { 
        validateStatus: (status) => status < 500 // Don't throw for 404
      });
      
      if (response.status === 404) {
        return null; // Profile doesn't exist yet
      }
      
      // Axios interceptor in api/index.ts handles 401 automatically
      
      return response.data;
    } catch (error) {
      console.error('Error in getProfile:', error);
      throw error;
    }
  },
  
  async getMyProfile(): Promise<Profile | null> {
    return this.getProfile();
  },
  
  async updateProfile(data: Partial<Profile>): Promise<Profile> {
    const response = await api.put(
      `${profileUrl}/me`,
      data
    );
    return response.data;
  },
  
  async updateMyProfile(data: Partial<Profile>): Promise<Profile> {
    return this.updateProfile(data);
  },
};
